import { useEffect, useState } from 'react';
export function useDietServiceDay() {
  const [day, setDay] = useState(() => new Date().toDateString());
  useEffect(() => {
    const refresh = () => setDay(new Date().toDateString());
    const timer = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return day;
}
